export default __webpack_public_path__ + "static/media/Picture2.8e5f22b8.jpg";